/**
 * Entry point of application.
 * Initializes third party components
 * Initializes routing
 */
/**
 * Import third-party modules
 */
import jQuery from 'jquery';
import {
  priceButton,
  BestOdds,
  BetHandler,
  pricesProvider,
} from 'rp-prices-component';
import { authReady } from 'rp-navigation';
import init from 'rp-gui-guide';
import popup, { backLink } from 'rp-popup';
import { cleanLegacy } from 'rp-cookie';
import initNavigationPrefs from 'rp-url-navigation-prefs';
import React from 'react';
import { render } from 'react-dom';
import { Router, useRouterHistory } from 'react-router';
import { createHistory } from 'history';
/**
 * Import styles
 */
import '../scss/main.scss';
/**
 * Import components
 */
import analyticsPage from './analyticsPage';
import BetslipInteractor from './utils/BetslipInteractor';
import component from './common/FetchDataPage';
import App from './App';
import NapsTable from './napsTable/DataWrapper';
import PressChallenge from './pressChallenge/PressChallenge';

jQuery.cookie('to_force_inclusion_in_code');

/**
 * Create browserHistory with basename of '/horse-racing-tips/'
 * in order to let react-router utilize history API
 */
const browserHistory = useRouterHistory(createHistory)({
    basename: '/horse-racing-tips/'
});
/**
 * Declare routes of application
 * @type {{path: string, component: ((p1:{children: *})), childRoutes: *[]}}
 */
const routes = {
    path: '/',
    component: App,
    childRoutes: [
        {
            component,
            path: 'naps-table',
            childComponent: NapsTable,
            url: '/tipping/naps-table/data/naps.json'
        },
        {
            component,
            path: 'press-challenge',
            childComponent: PressChallenge,
            url: '/tipping/press-challenge/data/press.json'
        }
    ]
};
/**
 * Init react router
 */
render(
    <Router history={browserHistory} routes={routes} onUpdate={() => { analyticsPage(); }} />,
    document.getElementById('root')
);
/**
 * Third party init
 */
cleanLegacy();
initNavigationPrefs();
init({
    svg: { polyfill: true }
});
popup();
backLink();
authReady.then();
const betslipInteracter = new BetslipInteractor();
// eslint-disable-next-line  no-new
new BestOdds();
// eslint-disable-next-line  no-new
new BetHandler();
priceButton.activate();
betslipInteracter.init()
    .then(betslipFeedName => pricesProvider.init(betslipFeedName));



// WEBPACK FOOTER //
// ./src/js/index.js